const richLinkSelect: NodeListOf<HTMLSelectElement> = document.querySelectorAll(".js-rich-link-select");

if (richLinkSelect) {
  richLinkSelect.forEach((select) => {
    select.addEventListener("change", ()=>{
      const rs = new RichLinkSelect(select);
      rs.ShowSelectElm();
    })
  })
}

class RichLinkSelect {

  select: HTMLSelectElement;

  constructor(select: HTMLSelectElement) {
    this.select = select;
  }

  GetOptionIndex(): number {
    return this.select.selectedIndex;
  }

  ShowSelectElm(): void {
    const num: number = this.GetOptionIndex();
    const parent: ParentNode = this.select.parentNode!;
    const selects: NodeListOf<HTMLElement> = parent.querySelectorAll(".js-rich-link-list");

    for(let i = 0; i < selects.length; i ++) {
      if (i == (num - 1)) {
        selects[i].style.display = "block";
      } else {
        selects[i].style.display = "none";
      }
    }

  }

}
